import React from 'react';

import {
  ErrorToastCloseButton,
  ErrorToastContainer,
  ErrorToastIcon,
  ErrorToastMessage,
} from './style';

interface ErrorToastProps {
  message: string;
  onClose: () => void;
}

export const ErrorToast: React.FC<ErrorToastProps> = ({ message, onClose }) => (
  <ErrorToastContainer role="alert">
    <ErrorToastIcon aria-hidden="true">⚠</ErrorToastIcon>

    <ErrorToastMessage>{message}</ErrorToastMessage>

    <ErrorToastCloseButton type="button" onClick={onClose} aria-label="Fechar">
      ✕
    </ErrorToastCloseButton>
  </ErrorToastContainer>
);
